import Vue from 'vue'
import Router from 'vue-router'
import layouts from '../layout'
import store from '../store'

const Home = () => import(/* webpackChunkName: "home" */ `../pages/Home.vue`)
const Register = () => import(/* webpackChunkName: "register" */ `../pages/Register.vue`)
const Discovery = () => import(/* webpackChunkName: "discovery" */ `../pages/Discovery.vue`)
const Discoverys = () => import(/* webpackChunkName: "discovery" */ `../pages/Discoverys.vue`)
const Detail = () => import(/* webpackChunkName: "detail" */ `../pages/DetailPage.vue`)
const About = () => import(/* webpackChunkName: "about" */ `../pages/About.vue`)
const Contact = () => import(/* webpackChunkName: "contact" */ `../pages/Contact.vue`)
const PrivacyPolicy = () => import(/* webpackChunkName: "privacy-policy" */ `../pages/PrivacyPolicy.vue`)
const FAQ = () => import(/* webpackChunkName: "dashboard" */ `../pages/FAQ.vue`)
const Blog = () => import(/* webpackChunkName: "dashboard" */ `../pages/Blog.vue`)
/** ADMIN */
const Login = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/Logins.vue`)
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/Dashboard.vue`)
const ManajemenUserAdmin = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/ManajemenUserAdmin.vue`)
const ManajemenDokter = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/ManajemenDokter.vue`)
const ManajemenKategori = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/ManajemenKategori.vue`)
const ManajemenSubKategori = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/ManajemenSubKategori.vue`)
const PaymentHistory = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/PaymentHistory.vue`)
const PayoutRequest = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/PayoutRequest.vue`)
const OfflineSchedule = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/OfflineSchedule.vue`)
const SubscribeSaham = () => import(/* webpackChunkName: "dashboard" */ `../pages/Admin/SubscribeSaham.vue`)
import RouterView from "../pages/RouterView.vue";
import { i18n } from "../main.js";

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/:lang",
      component: RouterView,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["id", "en"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: '/:lang',
          name: 'Home',
          component: Home
        },
        {
          path: '/:lang/register',
          name: 'Register',
          component: Register
        },
        {
          path: '/:lang/discovery',
          name: 'Discovery',
          component: Discovery
        },
        {
          path: '/:lang/discovery/:id',
          name: 'Discoverys',
          component: Discoverys
        },
        {
          path: '/:lang/detail/:id',
          name: 'Detail',
          component: Detail
        },
        {
          path: '/:lang/about',
          name: 'About',
          component: About
        },
        {
          path: '/:lang/contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/:lang/faq',
          name: 'FAQ',
          component: FAQ
        },
        {
          path: '/:lang/privacy-policy',
          name: 'Privacy Policy',
          component: PrivacyPolicy
        },
        {
          path: '/blog',
          name: 'Blog',
          component: Blog
        },

        // ADMIN
        {
          path: '/:lang/admin/login',
          alias: '/:lang/admin',
          name: 'Login',
          component: Login,
          meta: {
            admin: true,
            hideNavigation: true,
            layout: layouts.contenOnly
          }
        },
        {
          path: '/:lang/admin/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/manajemen-user-admin',
          name: 'ManajemenUserAdmin',
          component: ManajemenUserAdmin,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/manajemen-dokter',
          name: 'ManajemenDokter',
          component: ManajemenDokter,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/manajemen-kategori',
          name: 'ManajemenKategori',
          component: ManajemenKategori,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/manajemen-sub-kategori',
          name: 'ManajemenSubKategori',
          component: ManajemenSubKategori,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/payment-history',
          name: 'PaymentHistory',
          component: PaymentHistory,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/payout-request',
          name: 'PayoutRequest',
          component: PayoutRequest,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/offline-schedule',
          name: 'OfflineSchedule',
          component: OfflineSchedule,
          meta: {
            auth: true,
            admin: true
          }
        },
        {
          path: '/:lang/admin/subscribe-saham',
          name: 'SubscribeSaham',
          component: SubscribeSaham,
          meta: {
            auth: true,
            admin: true
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/id"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js